import { useState } from "react";
import { useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";
import SoftTagInput from "components/SoftTagInput";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import "react-toastify/dist/ReactToastify.css";

import ExternalUsersSharCard from "./ExternalUsersShareCard";

function ExternalUsersShareDialog({ open, onClose, onAccept }) {
  const [shareUsersEmails, setShareUsersEmails] = useState([]);
  const [tagInputError, setTagInputError] = useState(false);
  const [shareUsersLimitReached, setShareUsersLimitReached] = useState(false);
  const [emailAddressInputValue, setEmailAddressInputValue] = useState("");
  const { shareItemData } = useSelector((state) => state.portal.sharing);
  const MaxEmailAddressCharacterLength = 320;

  const handleClose = () => {
    onClose();
  };

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const handleTagsChange = (tags) => {
    const validEmails = tags.filter(validateEmail);

    if (validEmails.length > 10) {
      setShareUsersLimitReached(true);
      return;
    }

    setShareUsersEmails(validEmails?.map((e) => ({ email: e, access_type: "readOnly" })));
    setTagInputError(validEmails.length === 0);
  };

  const handleEmailAddressInputValueChange = (e) => {
    console.log("e ===", e);
    if (e.length <= MaxEmailAddressCharacterLength) {
      setEmailAddressInputValue(e);
      console.log("e ===", e);
    }
  };

  return (
    <Dialog
      className="external-users-share-modal"
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle>
        Share {shareItemData.item}: {shareItemData.item_name}
      </DialogTitle>
      <DialogContent sx={{ overflowY: "visible" }}>
        <SoftBox mt={1}>
          <SoftTagInput
            value={shareUsersEmails?.map((e) => e.email)}
            inputValue={emailAddressInputValue}
            onChange={handleTagsChange}
            addOnBlur
            mb={2}
            error={tagInputError || shareUsersLimitReached}
            onChangeInput={handleEmailAddressInputValueChange}
          />
          {tagInputError && (
            <SoftTypography variant="caption" color="error" fontWeight="light" mt={1}>
              Please enter at least one valid email address. <br />
            </SoftTypography>
          )}
          {shareUsersLimitReached && (
            <SoftTypography variant="caption" color="warning" fontWeight="light" mt={1}>
              You can only share up to 10 users at a time
              <br />
            </SoftTypography>
          )}
        </SoftBox>
        <SoftBox>
          <ExternalUsersSharCard
            shareUsersEmails={shareUsersEmails}
            setShareUsersEmails={setShareUsersEmails}
          />
        </SoftBox>
      </DialogContent>
      <DialogActions>
        <SoftButton variant="outlined" color="info" onClick={handleClose}>
          cancel
        </SoftButton>
        <SoftBox position="relative" marginLeft={1}>
          <SoftButton variant="contained" color="info" onClick={onAccept} disabled={false}>
            share
          </SoftButton>
        </SoftBox>
      </DialogActions>
    </Dialog>
  );
}

export default ExternalUsersShareDialog;
